export const INACTIVE = 0 //
export const ACTIVE = 1 //Green
export const INVITED = 2 //Purple
export const SUSPENDED = 3 // Orange

export const RE_STORE = 'RE_STORE'
export const RE_INVITE = 'RE_INVITE'
export const SUSPEND = 'SUSPEND'
export const DELETE = 'DELETE'

export const AUTHOR = 1
export const ADMIN = 2

export const headerPDF = (formatMessage) => [
  {
    header: formatMessage({ id: 'table.header.numberOfRow' }),
  },
  {
    header: formatMessage({ id: 'firstName.label' }),
  },
  {
    header: formatMessage({ id: 'lastName.label' }),
  },
  {
    header: formatMessage({ id: 'teamMembers.table.roles.label' }),
  },
  {
    header: formatMessage({ id: 'teamMembers.table.email.label' }),
  },
  {
    header: formatMessage({ id: 'phone.label' }),
  },
  {
    header: formatMessage({ id: 'text.status' }),
  },
]

export const headerCVS = (formatMessage) => [
  {
    label: formatMessage({ id: 'teamMembers.table.no.label' }),
    key: 'row',
  },
  {
    label: formatMessage({ id: 'firstName.label' }),
    key: 'firstName',
  },
  {
    label: formatMessage({ id: 'lastName.label' }),
    key: 'lastName',
  },
  {
    label: formatMessage({ id: 'teamMembers.table.roles.label' }),
    key: 'roles',
  },
  {
    label: formatMessage({ id: 'teamMembers.table.email.label' }),
    key: 'email',
  },
  {
    label: formatMessage({ id: 'phone.label' }),
    key: 'phone',
  },
  {
    label: formatMessage({ id: 'text.status' }),
    key: 'status',
  },
]
